// The rule for the school name on the School Info screen (BLU-275).
// Kept free of Angular so the rule can be unit tested on its own.

// allowed: English letters, the Arabic block, numbers, spaces, hyphen and round brackets.
// The lookahead asks for at least one letter or number, so "---", "()" and spaces alone fail.
// Arabic symbols sit inside the Arabic block, so \p{Lo} and \p{Nd} tell them apart from Arabic letters and digits.
export const SCHOOL_NAME_PATTERN = /^(?=.*[a-zA-Z0-9\p{Lo}\p{Nd}])[a-zA-Z؀-ۿ0-9 ()\-]+$/u;
